import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <CarouselSection />
        <FAQSection />
        <AboutSection />
        <ContactSection />
        <RankingSection />
        <MediaSection />
        <IndexSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <CardsSection />
        <TopicsSection />
        <FeaturesSection />
      </main>
      <Footer />
    </>
  );
}